import {ParsedUrlQuery} from 'querystring';

import {SignInParams} from './SignIn.types';

export const parseQueryParams = (query: ParsedUrlQuery): SignInParams => {
  const email = query.email as string;
  const returnUrl = query.return_to as string;
  const hasAccount = query.has_account
    ? (query.has_account as string).toLowerCase() === 'true'
    : undefined;

  return {
    ...(email ? {email} : {}),
    ...(returnUrl ? {returnUrl} : {}),
    ...(hasAccount !== undefined && {hasAccount}),
  };
};
